import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { changeUserPassword } from './api';

export type TSettingsState = {
  taskStatus: 'idle' | 'pending';
  // error: string;
};

const createSettingsSlice = (initialState: TSettingsState) =>
  createSlice({
    name: 'settings',
    initialState,
    reducers: {
      startTask(state) {
        state.taskStatus = 'pending';
      },
      endTask(state) {
        state.taskStatus = 'idle';
      },
      // onError(state, { payload }: PayloadAction<string>) {
      //   state.error = payload;
      // },
      // clearError(state) {
      //   state.error = '';
      // },
    },
    extraReducers: (builder) => {
      builder.addCase(changeUserPassword.fulfilled, (state, { payload }) => {
        toast(payload, { type: 'success', position: 'top-right' });
        // state.error = '';
        state.taskStatus = 'idle';
      });

      builder.addCase(changeUserPassword.rejected, (state, { payload }) => {
        state.taskStatus = 'idle';
        if (payload) {
          toast(payload as string, { type: 'error', position: 'top-right' });
        }
        // state.error = payload as string;
      });
    },
  });

const settingsSlice = createSettingsSlice({ taskStatus: 'idle' });
export const { endTask, startTask } = settingsSlice.actions;

export default settingsSlice.reducer;
